module.exports = __webpack_public_path__ + "img/TKK Fried Chicken.4bef1fff.svg";